import whiteRightIcon from "../../assets/white-right-icon.svg";
import editIcon from "../../assets/edit-latest-icon.svg";

const ClaimQueryDetailsForm = () => {
  const queryData = [
    {
      id: 1,
      date: "05/11/2025",
      time: "16:27:01",
      query:
        "Remarks - NEED FRACTION CHART, TUMOUR BOARD CERTIFICATE, HP REPORT AND BARCODE OF DRUGS AND DISCHARGE SUMMARY, TREATING DR REGISTRATION CERTIFICATE WITH VALID GOVT ID",
    },
  ];

  return (
    <div className="w-full">
      <div className="w-full h-0 border border-solid border-[#00000010] bg-[#00000010]" />

      <div className="pt-[30px]">
        {/* Header */}
        <div className="grid grid-cols-[60px_140px_1fr] gap-x-[64px] items-start">
          <div className="font-lufga font-normal text-[14px] leading-[12px] tracking-[-0.03em] text-[#5AC69F]">
            No.
          </div>

          <div className="font-lufga font-normal text-[14px] leading-[12px] tracking-[-0.03em] text-[#5AC69F]">
            Date & Time
          </div>

          <div className="font-lufga font-normal text-[14px] leading-[12px] tracking-[-0.03em] text-[#5AC69F]">
            Query
          </div>
        </div>

        {/* Body */}
        <div className="mt-[26px] flex flex-col gap-y-[24px]">
          {queryData.map((item) => (
            <div
              key={item.id}
              className="grid grid-cols-[60px_140px_1fr] gap-x-[64px] items-start"
            >
              {/* No */}
              <div className="font-lufga font-normal text-[14px] leading-[100%] tracking-[-0.03em] text-[#000000]">
                {item.id}.
              </div>

              {/* Date & Time */}
              <div className="flex flex-col font-lufga font-normal text-[14px] leading-[100%] tracking-[-0.03em] text-[#000000]">
                <span>{item.date}</span>
                <span className="mt-[4px]">{item.time}</span>
              </div>

              {/* Query */}
              <div className="font-lufga font-normal text-[14px] leading-[140%] tracking-[-0.03em] text-[#000000] break-words">
                {item.query}
              </div>
            </div>
          ))}
        </div>
      </div>

      {/* Footer */}
      <div className="flex justify-end items-center gap-[10px] mt-[40px]">
        <button className="w-[170px] h-[74px] xl:w-[101px] xl:h-[42px] 2xl:w-[101px] 2xl:h-[42px] rounded-full border-none bg-[#5AC69F] flex justify-center items-center gap-[10px] font-lufga text-[14px] text-white font-normal">
          SAVED
          <img src={whiteRightIcon} alt="saved" />
        </button>

        <button className="w-[42px] h-[42px] rounded-full border border-solid border-[#5AC69F] flex justify-center items-center bg-transparent">
          <img src={editIcon} alt="edit icon" />
        </button>
      </div>
    </div>
  );
};

export default ClaimQueryDetailsForm;
